/**
 * @documental
 * @export Underlined
 * @type
 * typographyComponent
 * @use
 * The `Underlined` component underlines the specified region of text.
 * @element
 * u
 * @className
 * underlined
 */
import { FC, PropsWithChildren } from "react";

import { BaseProps } from "../../BaseProps";
import { getHtmlPropsFromBaseProps } from "../../utilities/getHtmlPropsFromBaseProps";

import styles from "./styles.module.scss";

/**
 * The Underlined component properties.
 */

export interface UnderlinedProps extends BaseProps {}

/**
 * Specifies that text content should be displayed as underlined. Can be overridden
 * through the use of the [Strikethrough](../Strikethrough/README.md) component.
 */
export const Underlined: FC<PropsWithChildren<UnderlinedProps>> = (props) => {
  const { children } = props;
  const baseHtmlProps = getHtmlPropsFromBaseProps(props, { className: [styles.Underlined, "underlined"] });

  return <u {...baseHtmlProps}>{children}</u>;
};
